export const isOptionGroups = (options) => {
    if (options.length === 0) {
        return false;
    }
    return options[0].options !== undefined;
};
export const getOptionMap = (options) => {
    if (isOptionGroups(options)) {
        const result = new Map();
        options.forEach((optionGroup) => {
            (optionGroup.options || []).forEach((option) => {
                result.set(option.value || '', option);
            });
        });
        return result;
    }
    return new Map(options.map((opt) => [(opt === null || opt === void 0 ? void 0 : opt.value) || '', opt]));
};
